/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import { EcsperChallengePanel } from './EcsperChallengePanel.js';
import { EcsperPersonaPanel } from './EcsperPersonaPanel.js';
import { EcsperStandardPanel } from './EcsperStandardPanel.js';
import type { PanelRegistration } from './types.js';

export const panelRegistry: PanelRegistration[] = [
  {
    id: 'ecsper-standard',
    name: 'Ecsper Standard',
    brand: 'standard',
    component: EcsperStandardPanel,
    enabled: true,
    order: 1,
  },
  {
    id: 'ecsper-challenge',
    name: 'Ecsper Challenge',
    brand: 'challenge',
    component: EcsperChallengePanel,
    enabled: true,
    order: 2,
  },
  {
    id: 'ecsper-persona',
    name: 'Ecsper Persona',
    brand: 'persona',
    component: EcsperPersonaPanel,
    enabled: true,
    order: 3,
  },
];

/** Returns enabled panels sorted by {@link PanelRegistration.order}. */
export function getEnabledPanels(
  registry: readonly PanelRegistration[] = panelRegistry,
): readonly PanelRegistration[] {
  return registry.filter((panel) => panel.enabled).sort((a, b) => a.order - b.order);
}
